import React from 'react';
import moment from 'moment';
import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import Input from '../../Forms/Input';
import { conceptoToTotales } from '../../../utils/calculate.conceptos';
import BillEventsConceptos from './BillEvents.conceptos';
import BillEventsTotales from './BillEvents.totales';

interface BillEventsMainBillProps {
    toBillArgument: ToBillArguments<ToBillEvent>;
}

/** Already stamped bill the pending bill events relate to, read only */
function BillEventsMainBill({ toBillArgument }: BillEventsMainBillProps) {
    if (!toBillArgument) {
        return null;
    }
    const totales = conceptoToTotales(toBillArgument.MasterCFDI.conceptos);
    return (
        <div>
            <h4>Factura original (Factura relacionada)</h4>
            <div className="card table">
                <div className="cardBody">
                    <div className="row dateUuid">
                        <Input value={moment(toBillArgument.createdAt).format('DD MMMM YYYY,  hh:mm a')} label="Fecha emitida" type="text" disabled={true} />
                        <Input value={toBillArgument.uuid} label="UUID" type="text" disabled={true} />
                    </div>
                    <div className="row emisor">
                        <div className="row two">
                            <Input value={toBillArgument.MasterCFDI.serie || 'A'} label="Serie" type="text" disabled={true} />
                            <Input value={toBillArgument.MasterCFDI.folio || '1'} label="Folio" type="text" disabled={true} />
                        </div>
                    </div>
                    <div className="row emisor">
                        <Input value={toBillArgument.MasterCFDI.receptor.nombre} label="Receptor" type="text" disabled={true} />
                        <Input value={toBillArgument.MasterCFDI.receptor.rfc} label="RFC Receptor" type="text" disabled={true} />
                        <div className="row two">
                            <Input value={toBillArgument.MasterCFDI.formaPago} label="Forma de pago" type="text" disabled={true} />
                            <Input value={toBillArgument.MasterCFDI.metodoPago} label="Metodo de pago" type="text" disabled={true} />
                        </div>
                    </div>
                    <BillEventsConceptos conceptos={toBillArgument.MasterCFDI.conceptos} tasaRoundFactor={10000} />
                    <BillEventsTotales totales={totales} />
                </div>
            </div>
        </div>
    )
}

export default BillEventsMainBill;
